import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign.ts';
import { useOnboarding } from '@/pages/Onboarding/context';
import { DominateFooter } from '@/pages/Onboarding/Layouts/OwnAI_DominateV2/components/DominateFooter';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { HARDCODED_CATEGORIES } from '../../constants';
import { getSummaryScreenConfig } from '../../utils/getSummaryScreenConfig';

import {
  ContentContainerStyles,
  PageStyles,
  PlayerContainerStyles,
} from './SummaryIntro.styles';

export const SummaryIntro: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Summary Intro',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();
  const notes = webCampaign.getLayoutNotes();
  const config = getSummaryScreenConfig('summary-intro', notes);

  const handleNextStep = () => {
    userService.createOrUpdate({
      categories: HARDCODED_CATEGORIES,
      onboarding_data: {
        first_categories: HARDCODED_CATEGORIES,
      },
    });
    refreshUser();
    wizard.nextStep();
  };

  return (
    <PageStyles background="domination" mainImage={config.mainImage}>
      <IonContent>
        <ContentContainerStyles>
          <PlayerContainerStyles>
            <Player
              src="/assets/layout-own-ai-dominate/summary_screens/summary_intro.json"
              autoplay
              loop={false}
              keepLastFrame
            />
          </PlayerContainerStyles>
        </ContentContainerStyles>
        <DominateFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
          quoteText="That wasn't bad. Let's see if you can impress me again"
          buttonText="Yes, Mistress"
          variant="with-quotes"
        />
      </IonContent>
    </PageStyles>
  );
};
